import styled from 'styled-components'

export const GeneralInfoRentContractWrap = styled.div``
